import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import i18n from 'helpers/i18n';

import RegistrationTwoStepsForm from 'components/UI/Registration/RegistrationTwoStepsForm';

const RegistrationTwoStepsFormStyled = withStyles((theme) => ({
  root: {
},
}))(RegistrationTwoStepsForm);

class RegistrationTwoStepsFormWrapper extends Component {
  render() {
    /*
    const { onClose, onFormComplete, closeOnComplete,
        classes,
        $$event,
        $$events,
        onResize,
        $$user,
        showLogin,
        scrollOnMount,
        key,
        subscriptionPopup,
   } = this.props;
   */

    return <RegistrationTwoStepsFormStyled 
    showRecap={true}
    scrollOnMount={false}
/*
    $$event={$$event}
    $$events={$$events}
    onResize={onResize}
    $$user={$$user}
    showLogin={showLogin}
    //scrollOnMount={scrollOnMount}
    key={key}
  */
      //showRequiredLegend={false}
      //step={1}
      subscriptionPopup={i18n.get('subscriptionPopupText')}
      {...this.props}
    />;
  }
}

export default RegistrationTwoStepsFormWrapper;



// WEBPACK FOOTER //
// ./src/components/Registration/RegistrationTwoStepsForm.jsx